// extracted by mini-css-extract-plugin
module.exports = {"SwipeLeftToClose":"bez_a bhv_bk bhv_bl bhv_bo","SwipeLeftToClose--animating":"bez_b"};